import React, { useState, useEffect, useCallback } from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import FormDatosFacturacion from "./DatosFacturacionPymes";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { listarECivilesFetch, listarGenerosFetch, listarProvinciasFetch, listarCiudadesFetch, fetchConsultarIdentificacionAP, recuperarDatosFacturacionFetch, setRecuperarDatosFacturacion } from "../../../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import { FetchTotalesCabeceraCotizadores } from "../../../../redux/actions/ACarritoProductos";
import { FetchRenovacionItem } from "../../redux/aRenovaciones";

const ContainerDatosFacturacionPymes = (props) => {
  const {
    location,
    listarEstadosCiviles,
    listarGeneros,
    listarProvincias,
    listarCiudades,
    consultarIdentificacionProp,
    datosFacturacion,
    datosFacturacionDirecta,
    actualizarTotalesCabecera,
    catalogos,
    datosIdentificacion,
    dataFacturacion,
    dataFacturacion2
  } = props;

  const [cargando, setCargando] = useState(true);
  const [loadingPagadores, setLoadingPagadores] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const [esRenovacionDirecta, setEsRenovacionDirecta] = useState(false);
  const [renovacionIdLocal, setRenovacionIdLocal] = useState(null);

  const cargarDatosDesdeRenovacion = useCallback(async (renovacionId) => {
    try {
      const data = await FetchRenovacionItem(renovacionId);

      if (data && data.dataRenovacion) {
        const renovacion = data.dataRenovacion;
        const datosContratante = renovacion.reDatosContratante || {};
        const datosAsegurado = renovacion.reDatosAsegurado || {};
        const datosPagadorObj = renovacion.reDatosPagador || {};

        // Mapeo de datos del Pagador
        const pagadorIdentificacion = datosPagadorObj.reIdentificacion || datosPagadorObj.identificacion || "";
        let pagadorTipoDocumento = datosPagadorObj.reTipoDocumento || datosPagadorObj.codTipodocumento || "";
        if (!pagadorTipoDocumento && pagadorIdentificacion) {
          if (pagadorIdentificacion.length === 13) {
            pagadorTipoDocumento = "2"; // RUC
          } else if (pagadorIdentificacion.length === 10) {
            pagadorTipoDocumento = "1"; // Cédula
          }
        }

        let pagadorNombres = datosPagadorObj.reNombre1 || datosPagadorObj.cliNombres || "";
        let pagadorApellidos = datosPagadorObj.reApellido1 || datosPagadorObj.cliApellidos || "";
        if (!pagadorNombres && !pagadorApellidos && datosPagadorObj.reNombre1) {
          const rawName = datosPagadorObj.reNombre1 || "";
          if (pagadorTipoDocumento === "2") {
            pagadorNombres = rawName;
            pagadorApellidos = "";
          } else {
            const parts = rawName.trim().split(/\s+/);
            if (parts.length === 1) {
              pagadorNombres = parts[0];
              pagadorApellidos = "";
            } else if (parts.length === 2) {
              pagadorNombres = parts[0];
              pagadorApellidos = parts[1];
            } else if (parts.length === 3) {
              pagadorNombres = parts[0];
              pagadorApellidos = parts.slice(1).join(" ");
            } else {
              pagadorNombres = parts.slice(0, 2).join(" ");
              pagadorApellidos = parts.slice(2).join(" ");
            }
          }
        }

        const pagadorEmail = datosPagadorObj.reCorreo || datosPagadorObj.correo || datosPagadorObj.reEmail || "";
        const pagadorDireccion = datosPagadorObj.reDireccion || datosPagadorObj.direccion || "";
        const pagadorCelular = datosPagadorObj.reTelefono || datosPagadorObj.celular || datosPagadorObj.reCelular || "";
        const pagadorCodGenero = datosPagadorObj.reGenero || datosPagadorObj.codGenero || datosPagadorObj.reGeneroCod || "";
        const pagadorCodEstadoCivil = datosPagadorObj.reEstadoCivilCod || datosPagadorObj.codEstadoCivil || "";
        const pagadorFechaNacimiento = datosPagadorObj.reFechaNacimiento || datosPagadorObj.fechaNacimiento || null;
        const pagadorMongoIdentificador = datosPagadorObj.id || datosPagadorObj.mongoIdentificador || "";
        const pagadorProvincia = datosPagadorObj.reProvincia || datosPagadorObj.provincia || "";
        const pagadorCiudad = datosPagadorObj.reCiudad || datosPagadorObj.ciudad || "";

        // 1. Identificación fallback
        const identificacion = datosContratante.reIdentificacion || datosContratante.identificacion || datosAsegurado.reCodigoCliente || datosAsegurado.reIdentificacion || "";

        // 2. Tipo Documento fallback
        let tipoDocumento = datosContratante.reTipoDocumento || datosContratante.codTipodocumento || "";
        if (!tipoDocumento && identificacion) {
          if (identificacion.length === 13) {
            tipoDocumento = "2"; // RUC
          } else if (identificacion.length === 10) {
            tipoDocumento = "1"; // Cédula
          }
        }

        // 3. Nombres y apellidos fallback
        let cliNombres = datosContratante.reNombre1 || datosContratante.cliNombres || "";
        let cliApellidos = datosContratante.reApellido1 || datosContratante.cliApellidos || "";

        if (!cliNombres && !cliApellidos && (datosAsegurado.reNombre1 || datosAsegurado.reRazonSocial)) {
          const rawName = datosAsegurado.reRazonSocial || datosAsegurado.reNombre1 || "";
          if (tipoDocumento === "2") {
            cliNombres = rawName;
            cliApellidos = "";
          } else {
            const parts = rawName.trim().split(/\s+/);
            if (parts.length === 1) {
              cliNombres = parts[0];
              cliApellidos = "";
            } else if (parts.length === 2) {
              cliNombres = parts[0];
              cliApellidos = parts[1];
            } else if (parts.length === 3) {
              cliNombres = parts[0];
              cliApellidos = parts.slice(1).join(" ");
            } else {
              cliNombres = parts.slice(0, 2).join(" ");
              cliApellidos = parts.slice(2).join(" ");
            }
          }
        }

        // 4. Email fallback
        const email = datosContratante.reCorreo || datosContratante.correo || datosContratante.reEmail || datosAsegurado.reEmail || datosAsegurado.correo || "";

        // 5. Dirección fallback
        const direccion = datosContratante.reDireccion || datosContratante.direccion || datosAsegurado.reDireccion || datosAsegurado.direccion || "";

        // 6. Celular fallback
        const celular = datosContratante.reTelefono || datosContratante.celular || datosContratante.reCelular || datosAsegurado.reCelular || datosAsegurado.celular || "";

        // 7. Género y Estado Civil
        const codGenero = datosContratante.reGenero || datosContratante.codGenero || datosContratante.reGeneroCod || datosAsegurado.reGeneroCod || "";
        const codEstadoCivil = datosContratante.reEstadoCivilCod || datosContratante.codEstadoCivil || datosAsegurado.reEstadoCivilCod || "";

        // 8. Fecha Nacimiento
        const fechaNacimiento = datosContratante.reFechaNacimiento || datosContratante.fechaNacimiento || datosAsegurado.reFechaNacimiento || datosAsegurado.fechaNacimiento || null;

        // 9. ID mongo
        const mongoIdentificador = datosContratante.id || datosContratante.mongoIdentificador || datosAsegurado.id || datosAsegurado.mongoIdentificador || "";

        // 10. Provincia y Ciudad
        const provincia = datosContratante.reProvincia || datosContratante.provincia || datosAsegurado.reProvincia || datosAsegurado.provincia || "";
        const ciudad = datosContratante.reCiudad || datosContratante.ciudad || datosAsegurado.reCiudad || datosAsegurado.ciudad || "";

        // Extraer datos del producto para ValoresRenovacion
        const datosProducto = renovacion.reDatosProducto || {};
        const ramo = (datosProducto.reRamoProducto === 'PYMES' ? 'PYMES' : datosProducto.reRamo) || "PYMES";

        // Construir objeto compatible con campos del formulario DatosFacturacionPymes
        const datosFacturacionCompatible = {
          transaccion: true,
          _id: renovacionId,
          carDatosContratante: {
            cliIdentificacion: identificacion,
            cliTipoDocumento: tipoDocumento,
            cliNombres: cliNombres,
            cliApellidos: cliApellidos,
            cliEmail: email,
            cliDireccion: direccion,
            cliCelular: celular,
            cliCodGenero: codGenero,
            cliCodEstadoCivil: codEstadoCivil,
            cliFechaNacimiento: fechaNacimiento,
            mongoIdentificador: mongoIdentificador,
            provincia: provincia,
            ciudad: ciudad,
          },
          carDatosPagador: {
            cliIdentificacion: pagadorIdentificacion,
            cliTipoDocumento: pagadorTipoDocumento,
            cliNombres: pagadorNombres,
            cliApellidos: pagadorApellidos,
            cliEmail: pagadorEmail,
            cliDireccion: pagadorDireccion,
            cliCelular: pagadorCelular,
            cliCodGenero: pagadorCodGenero,
            cliCodEstadoCivil: pagadorCodEstadoCivil,
            cliFechaNacimiento: pagadorFechaNacimiento,
            mongoIdentificador: pagadorMongoIdentificador,
            provincia: pagadorProvincia,
            ciudad: pagadorCiudad,
          },
          carDescripcionRamo: ramo,
          ramo: ramo,
          // Datos de la renovación original para que ValoresRenovacion identifique ramo
          reDatosProducto: datosProducto,
          renovacionId: renovacionId,
          esRenovacionDirecta: true,
        };

        // Despachar al store de Redux como si fuera la respuesta del carrito
        datosFacturacionDirecta(datosFacturacionCompatible);

        // Cargar ciudades si ya hay provincia seleccionada
        if (provincia && provincia.value) {
          listarCiudades(provincia.value);
        }

        setEsRenovacionDirecta(true);
        setRenovacionIdLocal(renovacionId);
      }
    } catch (error) {
      console.error('Error al cargar datos de renovación:', error);
    }
  }, [datosFacturacionDirecta, listarCiudades]);

  useEffect(() => {
    const fetchInicial = async () => {
      await listarEstadosCiviles();
      await listarGeneros();
      await listarProvincias();

      const queryParams = new URLSearchParams(location.search);
      const renovacionIdURL = queryParams.get('renovacionId');
      const idCarritoURL = queryParams.get('id');

      if (renovacionIdURL) {
        // Flujo PYMES sin carrito: cargar datos directamente desde la renovación
        await cargarDatosDesdeRenovacion(renovacionIdURL);
      } else if (idCarritoURL) {
        // Flujo con carrito existente (legacy)
        const datosJSON = {
          empresa: "AIGMETROPOLITANA",
          plataforma: "WEB",
          idCarrito: idCarritoURL
        };
        await datosFacturacion(datosJSON);
      }

      setCargando(false);
    };

    fetchInicial();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (dataFacturacion2 !== undefined && dataFacturacion2 !== "") {
      let param = {
        pathIcono: dataFacturacion2.pathIconoTotalesCabecera ? dataFacturacion2.pathIconoTotalesCabecera : "",
        totalItems: dataFacturacion2.numItemsCarrito ? dataFacturacion2.numItemsCarrito : "0",
        totalPrima: (dataFacturacion2.carValoresTotales && dataFacturacion2.carValoresTotales.primaTotal) ? dataFacturacion2.carValoresTotales.primaTotal : "0.00",
        ramoCotizador: dataFacturacion2.carDescripcionRamo ? dataFacturacion2.carDescripcionRamo : "",
      }

      // Actualizamos cabecera solo en flujo de carrito normal
      if (!esRenovacionDirecta) {
        actualizarTotalesCabecera(param);
      }
    }
    // eslint-disable-next-line
  }, [dataFacturacion2, esRenovacionDirecta]);

  const onChangeProvincia = async (param) => {
    await listarCiudades(param);
  };

  const consultarIdentificacion = async (params) => {
    await consultarIdentificacionProp(params);
  };

  const handleLoadingChange = (loading, text = "") => {
    setLoadingPagadores(loading);
    setLoadingText(text);
  };

  const textosCargando = () => {
    if (dataFacturacion.recuperarDatosFacturacionIsLoading)
      return "Cargando información para facturación...";
    if (cargando)
      return "Cargando información para el pago...";
    if (catalogos.listarCiudadesIsLoading)
      return "Cargando catálogo de ciudades...";
    if (datosIdentificacion.consultarIdentificacionAPIsLoading)
      return "Cargando datos del cliente...";
    if (loadingPagadores)
      return loadingText || "Procesando...";
    return "";
  };

  return (
    <LoadingScreen
      loading={cargando || catalogos.listarCiudadesIsLoading || datosIdentificacion.consultarIdentificacionAPIsLoading || dataFacturacion.recuperarDatosFacturacionIsLoading || loadingPagadores}
      bgColor="#f1f1f1"
      spinnerColor="#001871"
      textColor="#676767"
      logoSrc={logo}
      text={textosCargando()}
    >
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            {!cargando &&
              <FormDatosFacturacion
                onChangeProvincia={onChangeProvincia}
                consultarIdentificacion={consultarIdentificacion}
                dataFacturacion={dataFacturacion.datosFacturacion}
                onLoadingExternoChange={handleLoadingChange}
                esRenovacionDirecta={esRenovacionDirecta}
                renovacionId={renovacionIdLocal}
              />
            }
          </div>
        </div>
      </main>
    </LoadingScreen>
  );
};

const mapStateToProps = state => ({
  datosIdentificacion: state.datosIdentificacionAP,
  catalogos: state.catalogosCotizacion,
  dataFacturacion: state.dataFacturacion,
  dataFacturacion2: state.dataFacturacion.datosFacturacion
});

const mapDispatchToProps = dispatch => {
  return {
    listarEstadosCiviles: () => dispatch(listarECivilesFetch()),
    listarGeneros: () => dispatch(listarGenerosFetch()),
    listarProvincias: () => dispatch(listarProvinciasFetch()),
    listarCiudades: (provincia) => dispatch(listarCiudadesFetch(provincia)),
    consultarIdentificacionProp: datos => dispatch(fetchConsultarIdentificacionAP(datos)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    datosFacturacionDirecta: (data) => dispatch(setRecuperarDatosFacturacion(data)),
    actualizarTotalesCabecera: (param) => dispatch(FetchTotalesCabeceraCotizadores(param)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerDatosFacturacionPymes)
);
